import { render } from "./FriendIndexView.vue?vue&type=template&id=6c42b9dd&scoped=true"
import script from "./FriendIndexView.vue?vue&type=script&lang=js"
export * from "./FriendIndexView.vue?vue&type=script&lang=js"

import "./FriendIndexView.vue?vue&type=style&index=0&id=6c42b9dd&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c42b9dd"]])

export default __exports__